import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as accountCampaignPricingEmailFinderActions from "../actions/account_campaign_pricing_email_finder_actions";
import * as accountCampaignPricingEmailFinderTypes from "../types/account_campaign_pricing_email_finder_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";
import { endpoints } from "../endpoints";

function* getPricingOfAccountEmailFinderCampaign(action) {
  try {
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL_FINDER}/${action.payload.id}`);
    if (res.status === 200) {
      yield put(accountCampaignPricingEmailFinderActions.getPricingOfAccountEmailFinderCampaignSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingEmailFinderActions.getPricingOfAccountEmailFinderCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingEmailFinderActions.getPricingOfAccountEmailFinderCampaignError(e));
  }
}

function* editPricingOfAccountEmailFinderCampaign(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL_FINDER}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(accountCampaignPricingEmailFinderActions.editPricingOfAccountEmailFinderCampaignSuccess(res.data));
      yield put(accountCampaignPricingEmailFinderActions.getPricingOfAccountEmailFinderCampaignRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingEmailFinderActions.editPricingOfAccountEmailFinderCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingEmailFinderActions.editPricingOfAccountEmailFinderCampaignError(e));
  }
}

export default function* accountCampaignPricingEmailFinderSaga() {
  yield takeLatest(accountCampaignPricingEmailFinderTypes.getPricingOfAccountEmailFinderCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST, getPricingOfAccountEmailFinderCampaign);
  yield takeLatest(accountCampaignPricingEmailFinderTypes.editPricingOfAccountEmailFinderCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST, editPricingOfAccountEmailFinderCampaign);
}
